// extracted by mini-css-extract-plugin
export default {"delayReasonWrapper":"delayReasonItem_delayReasonWrapper__ntcal"};